/**
 * Business & Corporate Law hub — register with the global subcategory registry.
 */
import { BUSINESS_CORPORATE_LAW_SLUG, businessCorporateLawDefaultData } from "./businessCorporateLawData";
import {
  BusinessCorporateArticlesTab,
  BusinessCorporateMediaTab,
  BusinessCorporateOverviewTab,
} from "./BusinessCorporateLawDesign";

export const businessCorporateLawModule = {
  slug: BUSINESS_CORPORATE_LAW_SLUG,
  getDefaultData: () => businessCorporateLawDefaultData,
  Views: {
    overview: BusinessCorporateOverviewTab,
    articles: BusinessCorporateArticlesTab,
    media: BusinessCorporateMediaTab,
  },
};
